import React from "react";
import { Card, Row, Col } from "antd";
import AddNewTrackedWebsite from "../shared/TrackedWebsites/AddNewTrackedWebsite/AddNewTrackedWebsite";
const { Meta } = Card;

const DefaultLayout = props => {
  const onClick = e => {
    const pathname = e.currentTarget.getAttribute("data-target");
    props.push(pathname);
  };

  return (
    <Card
      title={
        <div className="ant-card-meta-detail">
          <div className="ant-card-meta-title">Welcome to SEO ToolBox!</div>
          <div className="ant-card-meta-description">Let's start improving your SEO</div>
        </div>
      }>
      <p style={{ marginBottom: "5px" }}>
        Setup your account in order to have a better SEO Site Checkup Toolbox experience.
      </p>
      <p>
        After the setup process you will have access to your Toolbox Dashboard, where you could see detailed information
        regarding your website's SEO performances.
      </p>

      <AddNewTrackedWebsite
        label="Setup your account"
        onAddTrackedWebsite={props.onAddTrackedWebsite}
        isAddingTrackedWebsite={props.isAddingTrackedWebsite}
      />
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 24 }, { xs: 8, sm: 16, md: 24, lg: 24 }]} style={{ marginTop: "24px" }}>
        <Col sm={24} lg={12} xl={8}>
          <Meta
            data-target="/analysis"
            className="empty-dashboard-box"
            avatar={
              <span className="custom-icon icon">
                <span className="icon custom-icon-seo-check"></span>
              </span>
            }
            title="SEO Checkup"
            description="Perform a full SEO Checkup for your site"
            onClick={e => onClick(e)}
          />
        </Col>
        <Col sm={24} lg={12} xl={8}>
          <Meta
            data-target="/white-label/reports"
            className="empty-dashboard-box"
            avatar={
              <span className="custom-icon icon">
                <span className="icon custom-icon-brand"></span>
              </span>
            }
            title="White Label Reports"
            description="Get customized SEO reports"
            onClick={e => onClick(e)}
          />
        </Col>
        <Col sm={24} lg={12} xl={8}>
          <Meta
            data-target="/site-speed"
            className="empty-dashboard-box"
            avatar={
              <span className="custom-icon icon">
                <span className="icon custom-icon-speed"></span>
              </span>
            }
            title="Site Loading Speed"
            description="Check your website's performance"
            onClick={e => onClick(e)}
          />
        </Col>

        <Col sm={24} lg={12} xl={8}>
          <Meta
            data-target="/broken-links"
            className="empty-dashboard-box"
            avatar={
              <span className="custom-icon icon">
                <span className="icon custom-icon-broken-link"></span>
              </span>
            }
            title="Broken Links"
            description="Nobody likes 404 error page"
            onClick={e => onClick(e)}
          />
        </Col>
        <Col sm={24} lg={12} xl={8}>
          <Meta
            data-target="/site-outage"
            className="empty-dashboard-box"
            avatar={
              <span className="custom-icon icon">
                <span className="icon custom-icon-uptime"></span>
              </span>
            }
            title="Site Outage"
            description="Check your website's uptime status"
            onClick={e => onClick(e)}
          />
        </Col>
        <Col sm={24} lg={12} xl={8}>
          <Meta
            data-target="/sitemap-generator"
            className="empty-dashboard-box"
            avatar={
              <span className="custom-icon icon">
                <span className="icon custom-icon-sitemap"></span>
              </span>
            }
            title="Sitemap Generator"
            description="Generate sitemap.xml file"
            onClick={e => onClick(e)}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default DefaultLayout;
